module.exports = __webpack_public_path__ + "img/logo_lineaire.00fd782f.svg";